// extracted by mini-css-extract-plugin
module.exports = {"root":"BoxAccordions_root__1g7zj","boxes":"BoxAccordions_boxes__tRNNe","infoBox":"BoxAccordions_infoBox__3WzNM"};